import React from 'react';
import { JConfirmationBarStyled } from './j-confirmation-bar.styled';
import { JButton } from '@atoms/JButton';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import { ShowJConfirmationBarProps } from '@/contexts/JConfirmationBarContext';

export const JConfirmationBar = ({
  onClose,
  onConfirm,
}: ShowJConfirmationBarProps) => {
  const { t } = useTranslation();
  return (
    <JConfirmationBarStyled>
      <Stack direction={'row'} gap={2}>
        <JButton onClick={onClose} size="small" variant="text">
          {t('CANCEL')}
        </JButton>
        <JButton
          onClick={onConfirm}
          size="small"
          variant="contained"
          color="secondary"
        >
          {t('SAVE')}
        </JButton>
      </Stack>
    </JConfirmationBarStyled>
  );
};
